import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ShoppingCart from '@material-ui/icons/ShoppingCart';
import Button from '@/components/material-ui-kit/components/CustomButtons/Button';
import GridContainer from '@/components/material-ui-kit/components/Grid/GridContainer';
import styles from 'styles/jss/original/components/shoppings/detailButton';
import { IShopping } from '@/@types/generated/contentful';

const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
};

const DetailButton: React.FC<ComponentProps> = ({ shopping }) => {
  const { siteUrl } = shopping.fields;
  const classes = useStyles();

  return (
    <div className={classes.section}>
      <GridContainer className={classes.purchase}>
        <a href={siteUrl} target='_blank' rel='noopener noreferrer'>
          {/* @ts-expect-error */}
          <Button round color='danger'>
            <ShoppingCart /> &nbsp; 購入サイトへ
          </Button>
        </a>
      </GridContainer>
    </div>
  );
};

export default DetailButton;
